import EventBus from '../../wirebox/event-bus.js'
import '../../wirebox/components/cached-script.js'
import jQuery from 'jquery'

class GoogleLoaderModule {
    
    /**
     * Construct module
    */
    constructor() {
        
        /**
         * Whether Google API has been loaded
         * @type {boolean}
        */
        this.isLoaded = false
        
        /**
         * Whether Google API is being loaded
         * @type {boolean}
        */
        this.isLoading = false
        
        /**
         * Callbacks to execute once the API is loaded
         * @type {boolean}
        */
        this.callbacks = []
        
        this.bindEvents()
        
    }
    
    /**
     * Load Google API
     * @param callback
    */
    loadApi(callback) {
        
        //Execute callback if Google API has already been loaded
        if (this.isLoaded) {
            callback()
            return
        }
        
        //Add callback to callbacks list
        this.callbacks.push(callback)
        
        //Cancel if API is being loaded
        if (this.isLoading) {
            return
        }
        
        //Set that the API is being loaded
        this.isLoading = true
        
        //Load the API
        /*jQuery.cachedScript('https://www.google.com/jsapi', {
            success: () => {*/
            
                //Set that the API has been loaded
                this.isLoaded = true
                this.isLoading = false
                
                //Execute callbacks now that the API is loaded
                jQuery.each(this.callbacks, (i, cb) => {
                    cb()
                })
            
            /*}
        })*/
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('load-google-api', this.loadApi.bind(this))
    }
    
}

EventBus.subscribe('init-modules',  () => {
    new GoogleLoaderModule()
})

export default GoogleLoaderModule